import { DEFAULT_LOCALE, getLanguageCode, isKnownLocaleTag, languageToi18nCode } from "@pandas/core-ui";
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { configuratorApi } from "@/services";
import i18next from "../../i18n";

async function fetchPartnerDefaultLocale(partnerCode: string): Promise<string> {
	const config = await configuratorApi.getConfig(partnerCode);
	const defaultLang = config.languages[0];
	if (!defaultLang) return DEFAULT_LOCALE;
	return languageToi18nCode(defaultLang) ?? DEFAULT_LOCALE;
}

export const Route = createFileRoute("/$locale")({
	beforeLoad: async ({ params, location }) => {
		if (isKnownLocaleTag(params.locale)) {
			// Canonical form is the 2-letter language code (el-GR → el, EN → en).
			const canonical = getLanguageCode(params.locale);
			if (canonical !== params.locale) {
				const pathParts = location.pathname.split("/");
				pathParts[1] = canonical;
				throw redirect({
					to: pathParts.join("/"),
					search: location.search,
					replace: true,
				});
			}

			if (i18next.language !== canonical) {
				await i18next.changeLanguage(canonical);
			}
			sessionStorage.setItem("selectedLanguage", canonical);

			return { locale: canonical };
		}

		// Not a valid locale — treat it as a partner code
		const partnerCode = params.locale;
		const resolved = await fetchPartnerDefaultLocale(partnerCode).catch(() => DEFAULT_LOCALE);
		const locale = getLanguageCode(resolved);
		const pathSegments = location.pathname.split("/").filter(Boolean);
		pathSegments[0] = partnerCode;
		const newPath = `/${locale}/${pathSegments.join("/")}`;
		throw redirect({
			to: newPath,
			search: location.search,
			replace: true,
		});
	},
	component: LocaleLayout,
});

function LocaleLayout() {
	return <Outlet />;
}
